var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suppliers"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('SuppliersTable',{attrs:{"canCreate":_vm.canCreateSupplier},on:{"create-supplier":_vm.onCreateSupplier,"edit-supplier":_vm.onEditSupplier}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }